/**
 * Created by xupengwei on 2018/6/26.
 */
import Vue from 'vue';
import Vuex from 'vuex';

/* import common function */
import mutations from './mutations';
import actions from './action';
import getters from './getters';

// import demo from '../views/demo/store/index';
// import rule from '../views/rule/store/index';
// import history from '../views/history/store/index';

Vue.use(Vuex);

const state = {
  'version': '0.0.14',
  'ipMap': {
    '112.74.142.227': 'app-api-1.ictun.com',
    '47.89.2.238': 'app-api-2.ictun.com',
    '198.11.168.174': 'app-api-3.ictun.com',
    '52.28.159.185': 'app-api-4.ictun.com',
    '49.4.90.223': 'app-api-22.ictun.com',
  },
  'blobIpMap': {
    '112.74.142.227': 'app-blob-1.ictun.com',
    '47.89.2.238': 'app-blob-2.ictun.com',
    '198.11.168.174': 'app-blob-3.ictun.com',
    '52.28.159.185': 'app-blob-4.ictun.com',
    '49.4.90.223': 'app-blob-22.ictun.com'
  },
  'http': 'https',
  'supportLan': ['zh-cn', 'en-us', 'zh', 'en'],
  // ============================== 以下测试数据填充
  // get参数中获取 set
  'clientId': '', // '9529b01d71f00672750b9c94063402c2', // '',
  'domain': '', // 'app-api-1.ictun.com', // '',
  'blobDomain': '', // 'app-blob-1.ictun.com', // '',
  // 从cookie中获取 set
  'token': '', // '1.e5f3f72cebc9f8dc9c85fd7df19e89e7', // '',
  'deviceId': '', // 'device--id', // '',
  'clientType': '', // 0,
  'lan': '', // 'zh-Hans',
  'scheme': '', // 'danales',
  // 初始化判断 set
  'os': '', // 'ios',
  'imgQuality': 2,
  // ============================== 以上测试数据填充
  // 程序中使用的常量
  'goUrl': '/api/app/v5/garage_door', // 'http://192.168.3.101:10088/api/app/v5/rule',
  'pagesizeLarge': 10000, // 每页数据量 Large
  // 'imgPre': 'http://web-static-1.oss-cn-shenzhen.aliyuncs.com/test/garage_door/',
  'imgPre': 'https://g.danale.net/web/app/garage-door-m-web/intl/static/',
  // mask
  'dataDarkMask': false,
  'dataTransMask': false,
  'clickDarkMask': false,
  'clickDarkMaskCallbackFunc': null,
  'clickTransMask': false,
  'clickTransMaskCallbackFunc': null,
  // alert win
  'showAlert': false,
  'alertTitle': '',
  'alertDesc': '',
  'alertBtnText': '',
  'alertCallbackFunc': null,
  // confirm win
  'showConfirm': false,
  'confirmTitle': '',
  'confirmDesc': '',
  'confirmLBtnText': '',
  'confirmRBtnText': '',
  'confirmLBtnCallbackFunc': null,
  'confirmRBtnCallbackFunc': null,
  // loading
  'dataLoading': false,
  'openGLoading': false,
  // msg box
  'dataMsgBox': false,
  'dataWhiteMsgBox': false,
  'msgBoxContent': '',
  'requestOptions': {
    'url': '/api/app/v5/garage_door',
    'method': 'post',
    'requestData': null
  },
  'requestBlobOptions': {
    'url': '/api/app/v5/blob',
    'method': 'post',
    'requestData': null
  },
  'titleObj': {
    'currentTitle': '',
    'showRightBtn': '',
    'rightText': '',
    'rightFun': null,
    'hasLCallbackFunc': false,
    'leftFun': null,
  },
  'garageInfoObj': {
    'installLocation': 0,
    'connectMethod': 0,
    'motorFactroy': null,
    'motorModel': null,
    'mode': 1,
    'times': 0
  }
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  // modules: {
  //   demo: demo,
  //   rule: rule,
  //   history
  // }
});



// WEBPACK FOOTER //
// ./src/store/index.js